export const CurrencyCodes = ['EUR', 'PLN', 'KWD'] as const

export type CurrencyCode = (typeof CurrencyCodes)[number]

export const DEFAULT_CURRENCY = 'EUR' as const

export const getPrice = (
  number: number,
  currency: CurrencyCode,
  locale: string
) => {
  return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(
    number
  )
}

export const currencySign: Record<CurrencyCode, string> = {
  EUR: '€',
  PLN: 'zł',
  KWD: 'KD',
}

// ISO 4217 minor units
export const currencyDecimals: Record<CurrencyCode, number> = {
  EUR: 2,
  PLN: 2,
  KWD: 3,
}

export const DEFAULT_DECIMALS = currencyDecimals[DEFAULT_CURRENCY]

export const getCurrencyDecimals = (currency?: CurrencyCode | null) =>
  currency ? currencyDecimals[currency] : DEFAULT_DECIMALS
